import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sentinelOne = defineConnector({
  identifier: "sentinelOne",
  name: "SentinelOne",
  tagLine: "Endpoint security platform",
  keywords: "s1 singularity edr xdr endpoint detection and response antivirus",
  logo,
  protocol: "http",
  tags: ["featured", "security"],
  defaultUrlPattern: () => "https://[^/]*\\.sentinelone\\.net/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiToken,
        scheme: "ApiToken",
      },
    ]),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In the SentinelOne Management Console, click on your user name in the top-right corner, then select **My User**. Click **Generate** next to API Token to create a new token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "hostname",
          label: "Management console URL",
          required: true,
          placeholder: "yourcompany.sentinelone.net",
          target: { kind: "configuration", field: "consoleUrl" },
          helperText: "Your SentinelOne management console hostname",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ consoleUrl }) =>
      `https://${consoleUrl}/web/api/v2.1/system/status`,
  },
  publicEnvVars: ({ consoleUrl }) => ({
    SENTINEL_ONE_URL: consoleUrl ? `https://${consoleUrl}` : "",
  }),
});
